import React, { useState } from 'react';
import RequestHero from "../components/request-demo/heroSection"
import DemoRequestForm from "../components/request-demo/requestForm"
import Carousel from "../components/request-demo/requestCarousel"

const RequestDemo = () => {
  const [data, setIsData] = useState([
    {
      name: "Customer name or Company",
      description: 'Lorem ipsum dolor sit amet, dowl.Lorem ipsum dolor sit amet, dowl.Lorem ipsum dolor sit amet, dowl.Lorem ipsum dolor sit amet, dowl.Lorem ipsum dolor sit amet, dowl.Lorem ipsum dolor sit amet,dowl.'
    },
    {
      name: "Customer name or Company",
      description: 'Lorem ipsum dolor sit amet, dowl.Lorem ipsum dolor sit amet, dowl.Lorem ipsum dolor sit amet, dowl.Lorem ipsum dolor sit amet, dowl.Lorem ipsum dolor sit amet, dowl.Lorem ipsum dolor sit amet,dowl.'
    },
    {
      name: "Customer name or Company",
      description: 'Lorem ipsum dolor sit amet, dowl.Lorem ipsum dolor sit amet, dowl.Lorem ipsum dolor sit amet, dowl.Lorem ipsum dolor sit amet, dowl.Lorem ipsum dolor sit amet, dowl.Lorem ipsum dolor sit amet,dowl.'
    },
    {
      name: "Customer name or Company",
      description: 'Lorem ipsum dolor sit amet, dowl.Lorem ipsum dolor sit amet, dowl.Lorem ipsum dolor sit amet, dowl.Lorem ipsum dolor sit amet, dowl.Lorem ipsum dolor sit amet, dowl.Lorem ipsum dolor sit amet,dowl.'
    },
    {
      name: "Customer name or Company",
      description: 'Lorem ipsum dolor sit amet, dowl.Lorem ipsum dolor sit amet, dowl.Lorem ipsum dolor sit amet, dowl.Lorem ipsum dolor sit amet, dowl.Lorem ipsum dolor sit amet, dowl.Lorem ipsum dolor sit amet,dowl.'
    },
    {
      name: "Customer name or Company",
      description: 'Lorem ipsum dolor sit amet, dowl.Lorem ipsum dolor sit amet, dowl.Lorem ipsum dolor sit amet, dowl.Lorem ipsum dolor sit amet, dowl.Lorem ipsum dolor sit amet, dowl.Lorem ipsum dolor sit amet,dowl.'
    },
    {
      name: "Customer name or Company",
      description: 'Lorem ipsum dolor sit amet, dowl.Lorem ipsum dolor sit amet, dowl.Lorem ipsum dolor sit amet, dowl.Lorem ipsum dolor sit amet, dowl.Lorem ipsum dolor sit amet, dowl.Lorem ipsum dolor sit amet,dowl.'
    },
    {
      name: "Customer name or Company",
      description: 'Lorem ipsum dolor sit amet, dowl.Lorem ipsum dolor sit amet, dowl.Lorem ipsum dolor sit amet, dowl.Lorem ipsum dolor sit amet, dowl.Lorem ipsum dolor sit amet, dowl.Lorem ipsum dolor sit amet,dowl.'
    },
    {
      name: "Customer name or Company",
      description: 'Lorem ipsum dolor sit amet, dowl.Lorem ipsum dolor sit amet, dowl.Lorem ipsum dolor sit amet, dowl.Lorem ipsum dolor sit amet, dowl.Lorem ipsum dolor sit amet, dowl.Lorem ipsum dolor sit amet,dowl.'
    },
    {
      name: "Customer name or Company",
      description: 'Lorem ipsum dolor sit amet, dowl.Lorem ipsum dolor sit amet, dowl.Lorem ipsum dolor sit amet, dowl.Lorem ipsum dolor sit amet, dowl.Lorem ipsum dolor sit amet, dowl.Lorem ipsum dolor sit amet,dowl.'
    },
    {
      name: "Customer name or Company",
      description: 'Lorem ipsum dolor sit amet, dowl.Lorem ipsum dolor sit amet, dowl.Lorem ipsum dolor sit amet, dowl.Lorem ipsum dolor sit amet, dowl.Lorem ipsum dolor sit amet, dowl.Lorem ipsum dolor sit amet,dowl.'
    },
    {
      name: "Customer name or Company",
      description: 'Lorem ipsum dolor sit amet, dowl.Lorem ipsum dolor sit amet, dowl.Lorem ipsum dolor sit amet, dowl.Lorem ipsum dolor sit amet, dowl.Lorem ipsum dolor sit amet, dowl.Lorem ipsum dolor sit amet,dowl.'
    },
    {
      name: "Customer name or Company",
      description: 'Lorem ipsum dolor sit amet, dowl.Lorem ipsum dolor sit amet, dowl.Lorem ipsum dolor sit amet, dowl.Lorem ipsum dolor sit amet, dowl.Lorem ipsum dolor sit amet, dowl.Lorem ipsum dolor sit amet,dowl.'
    },
    {
      name: "Customer name or Company",
      description: 'Lorem ipsum dolor sit amet, dowl.Lorem ipsum dolor sit amet, dowl.Lorem ipsum dolor sit amet, dowl.Lorem ipsum dolor sit amet, dowl.Lorem ipsum dolor sit amet, dowl.Lorem ipsum dolor sit amet,dowl.'
    },
    {
      name: "Customer name or Company",
      description: 'Lorem ipsum dolor sit amet, dowl.Lorem ipsum dolor sit amet, dowl.Lorem ipsum dolor sit amet, dowl.Lorem ipsum dolor sit amet, dowl.Lorem ipsum dolor sit amet, dowl.Lorem ipsum dolor sit amet,dowl.'
    },
  ])
  return (
    <div className="w-full">
      <RequestHero/>
      <DemoRequestForm/>
      <Carousel data={data}/>
    </div>
  );
};

export default RequestDemo;
